const patientSearch = {
  noSuggestions:
    "<0><0><0/></0><1><0>Couldn't find anything...</0><1><0>Clear search</0> or <2>Add a {{patientTerm}}</2></1></0>",
  searchBarPlaceholder: "Search by {{patientTerm}} name or email...",
  NoPatientsFound: "No patients found.",
  AddAPatient: "Add a {{patientTerm}}",
  searchPatients: "Search {{patientTerm}}",
  searchForPatient: "Search for a {{patientTerm}}",
  addPatient: "+ New {{patientTerm}}",
  clerk: {
    Settings: "Settings",
    YourAccount: "Your Account",
    RecentlyActivatedTreatmentPlans: "Recently activated plans",
    FromPractitioner: "<0>From:</0> {{practitionerFullName}}",
    ActivatedDate: "<0>Activated:</0> {{availableAt}}",
    NoRecentTreatmentPlans: "No recently activated treatment plans found",
  },
} as const;

export { patientSearch };
